import { useContext } from 'react'

import Gr4vyCheckoutSessionContext from './gr4vy-checkout-session.context'

export function useGr4vyCheckoutSession() {
  const context = useContext(Gr4vyCheckoutSessionContext)

  if (context === undefined) return {}

  return context
}
